<template>
<div>
    <div id="cartDrawer" class="cartDrawer" :style="`width : ${openCart ? '65%' : '0'}`">
      <div class="container-fluid" style="height : 100%">
        <div style="display : flex; justify-content : space-between">
            <div>
                <span style="font-size : 24px;line-height : 24px; font-weight : 700">Unit Cart</span>
                <span style="font-size : 20px;line-height : 24px; font-weight : 500">({{cartItemList.length}} Units)</span>
            </div>
            <div>
                <button type="button" class="close" @click="openCloseCart" >
                    &times;
                </button>
            </div>
            
        </div>
        <hr class="dashed">
        <div id="searchBar" class="mt-3" v-if="cartItemList.length > 0">
          <div class="form-group row">
            <label for="search-vendor" class="col-sm-12 col-form-label pb-1" style="font-weight : 700;font-size : 14px;">
              Vendor
            </label>
            <div class="col-sm-12">
              <multiselect v-model="selectedVendor" :options="vendorOptions" label="partnerName" :allow-empty="true" :select-label="''" :deselect-label="''" placeholder="Pilih Vendor" track-by="partnerName" :multiple="false" :close-on-select="true"></multiselect>
            </div>
          </div>
        </div>
        <!-- Select All Checkbox -->
        <div class="select-all-container d-flex justify-content-between align-items-center" v-if="cartItemList.length > 0">
            <div class="checkbox-wrapper">
                <input type="checkbox" id="selectAll" @change="selectAllItems()" :checked="selectedItems.length == cartItemList.length">
                <label for="selectAll">SELECT ALL UNITS</label>
            </div>
            <button 
              v-if="selectedItems.length > 0"
              type="button" 
              class="btn btn-link text-danger p-0 remove-btn" 
              @click="handleBulkDelete()"
              style="font-size: 0.8125rem; font-weight: 400; text-decoration: none; letter-spacing: 0.025rem;"
            >
                <span>REMOVE FROM CART</span>
            </button>
        </div>
        <div id="item'list" class="overflow-auto" style="height : 65%;" v-if="cartItemList.length > 0">
          <div v-for="data in cartItemList" :key="data.id">
            <div 
              class="card col-12 mb-3" 
              :style="`${showErrorUnit && errorUnitList.includes(data.id) ? 'border-color:rgba(255, 52, 68, 1);' : selectedItems.includes(data) ? 'background-color:#EFF6FF':'' }`" 
            >
              <div class="pt-2">
                <table id="borderless-table" :style="`width : 100%;`">
                  <thead>
                    <tr>
                      <td style=" text-align: center; padding-bottom : 10px;padding-right: 10px;">
                        <div class="checkbox-wrapper">
                          <input type="checkbox" v-model="selectedItems" :value="data" />
                        </div>
                      </td>
                      <td style="width : 40%; padding-bottom : 10px; padding-right: 10px;">
                        <span style="font-weight : 700; font-size:14px;line-height : 20px;">
                          ORDER DETAILS
                        </span>
                      </td>
                      <td style="width : 35%;padding-bottom : 10px;">
                        <span style="font-weight : 700; font-size:14px;line-height : 20px;">
                          PRODUCT DETAILS
                        </span>
                      </td>
                      <td style="width : 25%;padding-bottom : 10px;">
                        <span style="font-weight : 700; font-size:14px;line-height : 20px;">
                          PRODUCT CODE
                        </span>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style=" text-align: center;"></td>
                      <td rowspan="2" style="vertical-align:top; padding-right: 10px;">
                        <div style="font-size : 16px;line-height : 24px;">{{data.orderGroupHash}}</div>
                        <div style="font-size : 16px;line-height : 24px;font-weight : 700;">{{data.companyName}}</div> 
                        <div style="font-size : 16px;line-height : 24px;">Start : {{data.startRent}}</div>
                        <div style="font-size : 16px;line-height : 24px;">End : {{data.endRent}}</div>
                      </td>
                      <td rowspan="2" style="vertical-align:top;">
                        <div  style="font-size : 16px;line-height : 24px;">
                          {{`${data.brand} ${data.model} ${data.specifications}`}}
                        </div>
                      </td>
                      <td style="font-size : 16px;line-height : 24px;vertical-align:top;padding-right: 10px;">
                        <div
                          class="item-badge"
                          style="background-color: #3098F71A;"
                          >
                            {{data.orderCode}}
                        </div>
                      </td>
                      <td style="vertical-align:top;">
                        <button class="btn btn-sm btn-outline-danger" id="btn-remove-from-cart" style=" float: right;" data-toggle="tooltip" data-placement="bottom" title="Remove from cart" @click="handleRemoveFromCart(data.itemId)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M6.66675 10L6.66675 8" stroke="#C70E1D" stroke-width="1.5" stroke-linecap="round"/>
                            <path d="M9.33325 10L9.33325 8" stroke="#C70E1D" stroke-width="1.5" stroke-linecap="round"/>
                            <path d="M2 4.66699H14V4.66699C12.8954 4.66699 12 5.56242 12 6.66699V9.33366C12 11.2193 12 12.1621 11.4142 12.7479C10.8284 13.3337 9.88562 13.3337 8 13.3337V13.3337C6.11438 13.3337 5.17157 13.3337 4.58579 12.7479C4 12.1621 4 11.2193 4 9.33366V6.66699C4 5.56242 3.10457 4.66699 2 4.66699V4.66699Z" stroke="#C70E1D" stroke-width="1.5" stroke-linecap="round"/>
                            <path d="M6.71202 2.24706C6.78798 2.17618 6.95538 2.11355 7.18824 2.06888C7.4211 2.02421 7.70641 2 7.99992 2C8.29343 2 8.57874 2.02421 8.8116 2.06888C9.04446 2.11355 9.21185 2.17618 9.28782 2.24706" stroke="#C70E1D" stroke-width="1.5" stroke-linecap="round"/>
                          </svg>
                        </button>
                      </td>
                    </tr>
                    <!-- <tr>
                      <td style="vertical-align:bottom;">
                        <button class="btn btn-sm btn-outline-danger" id="btn-remove-from-cart" style=" float: right;" data-toggle="tooltip" data-placement="bottom" title="Remove from cart" @click="removeFromCart(data.itemId)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M6.66675 10L6.66675 8" stroke="#C70E1D" stroke-width="1.5" stroke-linecap="round"/>
                            <path d="M9.33325 10L9.33325 8" stroke="#C70E1D" stroke-width="1.5" stroke-linecap="round"/>
                            <path d="M2 4.66699H14V4.66699C12.8954 4.66699 12 5.56242 12 6.66699V9.33366C12 11.2193 12 12.1621 11.4142 12.7479C10.8284 13.3337 9.88562 13.3337 8 13.3337V13.3337C6.11438 13.3337 5.17157 13.3337 4.58579 12.7479C4 12.1621 4 11.2193 4 9.33366V6.66699C4 5.56242 3.10457 4.66699 2 4.66699V4.66699Z" stroke="#C70E1D" stroke-width="1.5" stroke-linecap="round"/>
                            <path d="M6.71202 2.24706C6.78798 2.17618 6.95538 2.11355 7.18824 2.06888C7.4211 2.02421 7.70641 2 7.99992 2C8.29343 2 8.57874 2.02421 8.8116 2.06888C9.04446 2.11355 9.21185 2.17618 9.28782 2.24706" stroke="#C70E1D" stroke-width="1.5" stroke-linecap="round"/>
                          </svg>
                        </button>
                      </td>
                    </tr> -->
                  </tbody>
                </table>
              </div>
            </div>  
          </div>
        </div>
        <div id="item'list" class="mb-3 mt-5 overflow-auto" style="height : 5%;" v-else>
          <div>Your unit cart is empty</div>
        </div>
        <div style="width : 100%; justify-content: center;" v-if="cartItemList.length == 0">
          <button class="btn btn-primary"  style="width : 100%"  @click="openCloseCart" >
            Pilih data untuk membuat Batch
          </button>
        </div>
        <div class="row" v-else>
          <div class="col-12 mt-2 mb-3">
           <div style="display : flex; justify-content :flex-end;">
              <button class="btn btn-outline-primary mr-2" @click="openConfirmationModal(true)">No Issue Needed</button>
              <button class="btn btn-primary"  @click="openConfirmationModal(false)"  :disabled="cartItemList.length == 0">
                Buat Batch
              </button>
            </div>
          </div>
        </div>

       </div>
    </div>
    <div class="drawer-mask" :style=" `
        width: ${openCart ? '100vw' : '0'};
        opacity: ${openCart ? '0.6' : '0'}`"
        @click="openCloseCart">
    </div>
</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Swal from 'sweetalert2';
export default {
  name: "CartDrawer",
  props: [
    'openCart',
    'openCloseCart',
    'cartItemList',
    'vendorOptions',
    'removeFromCart',
    'bulkRemoveFromCart',
    'createBatch',
    'showErrorUnit',
    'errorUnitList'
  ],
  components: {
    Multiselect,
  },
  data() {
    return {
      loadingTable: false,
      selectedVendor : '',
      selectedItems : [],
      source: "",
      admin: "",
      permission: [],
      totalPage: 0,
      totalData: 0,
      currentPage: 1,
      itemPerPage: 10,
      loadingButtonSave: false,
      insuranceEdit: [{
        orderCode: "",
        productTitle: "",
        productCode: "",
        newOrderCode: "",
        year: 0,
        prorate: 0,
        sumInsured: 0,
        periodFrom: "",
        periodTo: ""
      }, ],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      },
      rateEdit: false,
      prorateEdit: false,
      selectInsurance: [],
      isSelectAll: false,
      polisList: [],
      token: localStorage.getItem("jwt"),
      password: "",
      disableSave: false,
      cancelInsurancePermission: false,
      canRedeclare : false,
    };
  },
  methods: {
    handleBulkDelete() {
      try{
        this.bulkRemoveFromCart()
        this.selectedItems =[]
      } catch(error) {
        return
      }
    },
    handleRemoveFromCart(itemId) {
      if(this.selectedItems.find(item => item.itemId == itemId)) {
        const removedIndex = this.selectedItems.findIndex(item => item.itemId == itemId)
        this.selectedItems.splice(removedIndex,1)
      }
      this.removeFromCart(itemId)
    },
    selectAllItems(){
      if(this.selectedItems.length == this.cartItemList.length) {
        this.selectedItems = []
      } else {
        this.selectedItems = [...this.cartItemList]
      }
    },
    openConfirmationModal(isNotIssue) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });
      swalWithBootstrapButtons.fire({
        title: `<strong style='font-size : 24px; font-weight : 600;'>${isNotIssue ?
        'Apakah kamu yakin untuk tidak menerbitkan polis pada unit ini? ?' : 
        'Apakah kamu yakin akan membuat batch baru ?'
        }</strong>`,
        icon: "warning",
        width: '32rem',
        html: `
            <div style="max-width : 100%">
              <span style="color : rgba(240, 100, 0, 1);font-size: 16px;"> ${isNotIssue ? 
              'Unit terpilih akan berubah status menjadi No Issue' : 
              'Unit akan dipindahkan ke menu <b>Batch Insurance</b>'
              }<?span>
            </div>
          `,
        reverseButtons: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: `Ya, saya yakin!`,
        cancelButtonText: `Batalkan`,
      }).then((result) => {
        if(result.isConfirmed) {
          this.createBatch(this.selectedVendor, isNotIssue)
          // this.selectedItems = []
        } else {  
          this.openCloseCart()
        }
      });
    },
    sendLog(w, x) {
      // var today = new Date();
      // var month = today.getMonth()+1
      // if (month < 10) {
      //     month = '0'+month
      // }
      // var dateDay = today.getDate()
      // if (dateDay < 10) {
      //     dateDay = '0'+dateDay
      // }
      // var hours = today.getHours()
      // if (hours < 10) {
      //     hours = '0'+hours
      // }
      // var minutes = today.getMinutes()
      // if (minutes < 10) {
      //     minutes = '0'+minutes
      // }
      // var second = today.getSeconds()
      // if (second < 10) {
      //     second = '0'+second
      // }
      // var date = today.getFullYear()+'-'+month+'-'+dateDay;
      // var time = hours + ":" + minutes + ":" + second;
      // var dateTime = date+' '+time;
      // var admin = this.admin
      // var command = 'add-logs'
      // // var productName = this.productNameChoose
      // this.$http.post(process.env.LOG_URL+"/company/"+x,{
      //     codeLogs: w,
      //     params: [],
      // },{
      //     headers: {'Asani-Token':localStorage.getItem('jwt')}
      // })
      // .then(response => {
      // })
      // .catch(error => {
      //     console.log(error)
      // })
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    searchData() {
      this.$router.push({
        path: "/partnership/insurance",
        query: {
          lesseeName: this.searchLesseeName,
          orderCode: this.searchOrderCode,
          startRentFrom: this.searchStartRentFrom,
          startRentTo: this.searchStartRentTo,
          endRentFrom: this.searchEndRentFrom,
          endRentTo: this.searchEndRentTo,
          productName: this.searchProductName,
          productCode: this.searchProductCode,
          insuranceStatus: JSON.stringify(this.searchInsuranceStatus),
          page: 1,
          itemPerPage: this.itemPerPage,
        },
      });
      location.reload();
      this.getData();
    },
    toDataPage(pagePost) {
      this.$router.push({
        path: "/partnership/insurance",
        query: {
          lesseeName: this.searchLesseeName,
          orderCode: this.searchOrderCode,
          startRentFrom: this.searchStartRentFrom,
          startRentTo: this.searchStartRentTo,
          endRentFrom: this.searchEndRentFrom,
          endRentTo: this.searchEndRentTo,
          productName: this.searchProductName,
          productCode: this.searchProductCode,
          insuranceStatus: JSON.stringify(this.searchInsuranceStatus),
          page: pagePost,
          itemPerPage: this.itemPerPage,
        },
      });
      location.reload();
      this.getData();
    },
    toPage(e) {
      this.$router.push(e);
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    openModal(modalName) {
      $("#modal" + modalName).modal("show");
    },
  },
  created() {
    const allPermission = JSON.parse(localStorage.getItem('roles'))
    this.cancelInsurancePermission = allPermission && allPermission.indexOf('15.2') >= 0
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.cekLogin();
    this.selectedItems = localStorage.getItem("selectedInsuranceCartItems") ? JSON.parse(localStorage.getItem("selectedInsuranceCartItems")) : [];
  },
  watch: {
    selectedItems: function (a) {
      localStorage.setItem('selectedInsuranceCartItem', JSON.stringify(a))
    },

    selectInsurance: function (a) {
      this.disableSave = false;
      localStorage.setItem("selectInsurance", JSON.stringify(a));
      for (var i = 0; i < a.length; i++) {
        if (a[i].year == null || a[i].sumInsured == "0") {
          this.disableSave = true;
        }
      }
    },
  },
  // computed: {
  // }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.remove-btn :hover {
  text-decoration: underline;
}
.select-all-container {
  background: #F8F9FA;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}
/* Checkbox styling */
.checkbox-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
        
.checkbox-wrapper input[type="checkbox"] {
  margin: 0;
  margin-right: 8px;
  width: 15px;
  height: 15px;
  cursor: pointer;
  accent-color: #247FEC;
}
        
.checkbox-wrapper label {
  color: #666;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
        
/* Hover effect */
.checkbox-wrapper:hover {
  opacity: 0.8;
}

#borderless-table {
  border-collapse: separate;
  border-spacing: 0px 5px;
}
#btn-remove-from-cart:hover {
  background-color: rgba(255, 52, 68, 0.5);
}

@media screen and (max-height: 450px) {
  .cartDrawer {padding-top: 15px;}
}
.drawer-mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 0; /* initially */
  height: 100vh;
  background: #000;
  opacity: 0.3;
  z-index: 199;
}
.cartDrawer {
  height: 100vh;
  width: 0;
  position: fixed;
  z-index: 200;
  top: 0;
  right: 0;
  background-color: #FFFFFF;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 30px;
}
.btn-view-cart:hover {
  background-color: rgba(214, 234, 253, 1);
}
.item-badge {
  display: inline-block;
  padding: 0.25em 0.8em;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 1rem;
  transition: color 0.15s;
  margin-right: 2px;
  color: #3098F7;
}
.btn-add-cart{
  border-radius: 0.6rem;
}
.btn-add-cart:hover {
  background-color: rgba(214, 234, 253, 1);
}
.btn-remove-cart{
  border-radius: 0.6rem;
}
.btn-remove-cart:hover {
  background-color: #FEF4EA;
}
.total-data {
  margin-top: 7px;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.one-line {
  display: flex;
  margin: 5px 0px;
}

.border-red {
  border-color: red;
}

.one-line .ol-label.storage {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label-roles {
  width: 130px;
  margin: 2px 0px;
}

.one-line .ol-label-price {
  width: 263px;
  margin: 2px 0px;
}

.one-line .ol-titik2 {
  width: 15px;
  margin: 2px 0px;
}

.stPrice-sch {
  width: 186px;
  margin: 7px 0px;
}

.delivery-titik2 {
  margin: 7px 0px;
  padding-right: 7px;
}

.input-group-addon {
  padding: 7px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555;
  text-align: center;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
  margin: 0px 0px 0px 0px;
  height: fit-content;
}

.label-addon-rp {
  margin: 5px 0px;
}

.modal-lg,
.modal-xl {
  max-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/components/Insurance/CustomComponent/CartDrawer.vue